import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { PropertyService } from '../../property';
import { AlertService } from '../../../_services';
import { ApiResponse } from '../../../_models';
import { Feature } from '@app/_components/property/feature';
import { FeatureService } from '@app/_components/property/feature';
import { BedService } from './bed.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BedFormComponent } from './components/bed-form/bed-form.component';

@Component({
    selector: 'app-bed',
    templateUrl: './bed.component.html',
    styleUrls: ['./bed.component.css'],
    providers: [
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ],
    standalone: false
})



export class BedComponent implements OnInit
{

	constructor(private router: Router,
		private activatedRoute: ActivatedRoute,
		private bedService: BedService,
		private featureService: FeatureService,
		private alertService: AlertService,
		private location: Location,
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
	)
	{
	}



	// data
	@Input() beds: any[] = [];
	@Input() bedroomId: number;
	apiResponse: ApiResponse;


	formLoading: any;
	formAlert: String;

	ngOnInit()
	{
		// this.findBedsBybedroomId();
	}

	findBedsBybedroomId()
	{
		try
		{
			// stop here if form is invalid
			if (!this.bedroomId)
			{
				return;
			}

			this.formLoading = true;

			this.bedService.findBedsByBedroomId(this.bedroomId)
				.subscribe(
					res =>
					{
						console.log('bed-findBedsBybedroomId SUCCESS: ' + JSON.stringify(res));
						this.apiResponse = res;
						this.beds = res.data.beds;

					},
					err =>
					{
						console.log('bed-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}


	openFormAdd()
	{
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data
		dialogConfig.data = {
			bedroomId: this.bedroomId,
			title: 'Add Bed'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(BedFormComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(

			data =>
			{
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addBed(data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	/**
	 *
	 * EventEmitter Callbacks
	 * To edit the list show add/edit/delete in real time
	 *
	 */

	addBed(event)
	{
		console.log('Adding bed: ' + event);
		// if we don't have a bed array yet...
		if (!this.beds)
		{
			this.beds = [];
		}
		this.beds.push(event);
		this.formAlert = 'Bed #' + event.bedId + ' added.';
	}


	updateBed(event)
	{
		console.log('Updating Bed: ' + JSON.stringify(event));
		let itemIndex = this.beds.findIndex(item => item.bedId === event.bedId);
		this.beds[itemIndex] = event;
	}


	deleteBed(event)
	{
		console.log('Removing Bed: ' + event);
		this.beds = this.beds.filter(item => item !== event);
	}
}
